import { Component, OnInit, ChangeDetectionStrategy, OnChanges } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { EdpModalService } from "@edp-components/edp-modal";
import { SendShareEmail } from "@edp-store/actions/edpe.actions";
import { lastResponse, showLoader } from "@edp-store/selectors/layout.selectors";
import { IAppState } from "@edp-store/state/app.state";
import { NewEmailValidator } from "@edp-validators/new-email.validator";
import { select, Store } from "@ngrx/store";

@Component({
    selector: "edp-e-mgm-mail-modal",
    templateUrl: "./edp-e-mgm-mail-modal.component.html",
    styleUrls: ["./edp-e-mgm-mail-modal.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EdpEMgmMailModalComponent implements OnInit {
    public form: FormGroup;
    public isSubmitted = false;
    public lastResponse$ = this.store.pipe(select(lastResponse));
    public submitValidation = false;
    public sentEmail: string;
    public mailSent = false;

    constructor(private edpModalService: EdpModalService, private store: Store<IAppState>, private readonly formBuilder: FormBuilder) {}

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            email: [null, [Validators.required, NewEmailValidator]],
        });

        this.form.valueChanges.subscribe(result => {
            console.log(this.form.status);
            console.log(this.submitValidation);

            if (this.form.status === "VALID") {
                if (this.sentEmail !== this.email) {
                    this.submitValidation = true;
                } else {
                    this.submitValidation = false;
                }
            } else {
                this.submitValidation = false;
            }
        });
    }

    get email() {
        return this.form.get("email").value;
    }

    get isValid() {
        return this.form.valid;
    }

    public sendEmail(): void {
        if (this.form.valid && !this.isSubmitted) {
            this.store.dispatch(new SendShareEmail({ type: "email", sendTo: this.email }));

            this.lastResponse$.subscribe(data => {
                if (data) {
                    this.isSubmitted = true;
                    this.mailSent = true;
                    this.submitValidation = false;
                    this.sentEmail = this.email;
                }
            });
        }
    }

    public inputFocus(event: Event, postionElement: HTMLElement): void {
        event.preventDefault();
        event.stopPropagation();
        // this.removeOverflow(postionElement);

        if (!!this.isSubmitted) {
            this.form.get("email").setValue("");
            this.isSubmitted = false;
            this.mailSent = false;
            this.submitValidation = false;
            document.getElementById("email-input").removeAttribute("placeholder");
        }
    }

    public closeModal(action: boolean): void {
        this.edpModalService.close(action);
    }

    public close() {
        this.closeModal(true);
    }
}
